<script setup lang="ts">
import MainBreadcrumbs from "../../../ui/components/header/MainBreadcrumbs.vue";
import { ref } from "vue";
import { useBaseStore } from "@/stores/base";
import { t } from "@/plugins/i18n";

const store = useBaseStore();

const breadcrumbs = [
	{
		title: "Environment",
		disabled: true,
		to: "/environment",
	},
];

type tabsType = {
	itemId: string;
	translationKey: string;
	icon: string;
	to: string;
	visible: boolean;
};

const tabs: tabsType[] = [
	{
		itemId: "general",
		translationKey: "environment.tabs.general",
		icon: "fa-sliders",
		to: "/environment/general-settings",
		visible: true,
	},
	{
		itemId: "authentication",
		translationKey: "environment.tabs.authentication",
		icon: "fa-shield-halved",
		to: "/environment/authentication",
		visible: true,
	},
	{
		itemId: "preset-filters",
		translationKey: "environment.tabs.presetFilters",
		icon: "fa-filter",
		to: "/environment/preset-filters",
		visible: useBaseStore().currentUser?.derivedPermissions.includes(
			"can_manage_explorer"
		),
	},
	{
		itemId: "permissions",
		translationKey: "environment.tabs.permissions",
		icon: "fa-list-check",
		to: "/environment/permissions",
		visible: true,
	},
	{
		itemId: "notification-events",
		translationKey: "environment.tabs.notificationEvents",
		icon: "fa-bell-on",
		to: "/environment/notification-events",
		visible: true,
	},
	{
		itemId: "clickhouse-server",
		translationKey: "environment.tabs.clickhouseServer",
		icon: "fa-database",
		to: "/environment/clickhouse-server",
		visible: true,
	},
	{
		itemId: "legacy-mysql-server",
		translationKey: "environment.tabs.legacyMysqlServer",
		icon: "fa-scroll-old",
		to: "/environment/legacy-mysql-server",
		visible: true,
	},
	{
		itemId: "booking-experts",
		translationKey: "environment.tabs.bookingExperts",
		icon: "fa-book",
		to: "/environment/booking-experts",
		visible:
			store.currentEnvironment?.modules?.booking_experts !== undefined &&
			store.currentUser?.derivedPermissions.includes(
				"can_manage_booking_experts"
			),
	},
	{
		itemId: "color-palettes",
		translationKey: "environment.tabs.colorPalettes",
		icon: "fa-palette",
		to: "/environment/color-palettes",
		visible: true,
	},
	{
		itemId: "ai-prompts",
		translationKey: "environment.tabs.aiPrompts",
		icon: "fa-robot",
		to: "/environment/ai-prompts",
		visible:
			store.HAS_ENVIRONMENT_FEATURE("environment_supports_ai_assist") &&
			store.currentUser?.derivedPermissions.includes("can_ask_ai"),
	},
];

const activeTab = ref(null);
</script>

<template>
	<main-breadcrumbs :breadcrumbs="breadcrumbs" />

	<v-tabs v-model="activeTab" center-active show-arrows>
		<v-tab
			v-for="tab in tabs"
			v-show="tab.visible"
			:key="tab.itemId"
			:value="tab.itemId"
			color="primary"
			:to="tab.to"
		>
			<i :class="`fa-duotone ${tab.icon} fa-lg`"></i>
			<div class="tab-text">
				{{ t(tab.translationKey) }}
			</div>
		</v-tab>
	</v-tabs>
	<v-divider />
	<div>
		<router-view />
	</div>
</template>

<style lang="scss">
.tab-text {
	margin-left: 10px;
}

.card-border-right {
	border-left: 50px solid rgb(var(--v-theme-borderColor));
}
</style>
